import type { JSX } from 'react';

import type { QuestionActivityItem } from '../../model/activity';

interface QuestionActivityContentProps {
  item: QuestionActivityItem;
}

const QuestionActivityContent = ({ item }: QuestionActivityContentProps): JSX.Element => (
  <div className="flex flex-col gap-1.5">
    <p className="m-0 text-sm text-text-default font-body">{item.question}</p>
    {item.answer ? (
      <p className="m-0 line-clamp-1 text-xs text-text-muted font-body">
        <span className="font-semibold text-text-default">Respuesta:</span> {item.answer}
      </p>
    ) : null}
  </div>
);

export default QuestionActivityContent;
